import Form from 'components/Form';

import { Fragment } from 'react';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const GuardianInfo = (props: Props) => {
  const { disabled, register } = props;

  const infos = [
    { title: '성명', value: 'guardian_name1' },
    { title: '생년월일', value: 'guardian_birth' },
    { title: '연락처', value: 'guardian_contact' },
    { title: '주소', value: 'guardian_address' },
    { title: '관계', value: 'guardian_relation' },
  ];

  return (
    <Fragment>
      <SectionTitle title="법정대리인 정보" />
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        {infos.map(({ title, value }) => (
          <RowContent
            title={title}
            titleRatio={1.3}
            childrenRatio={title === '주소' ? 6.3 : 2.5}
          >
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              {...register(`${value}`)}
            />
          </RowContent>
        ))}
      </RowContainer>
    </Fragment>
  );
};

export default GuardianInfo;
